import {
  columnOrderingFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  createExpandedRowModel,
  rowExpandingFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
  tableFeatures,
} from "@tanstack/react-table";

/** Shape of `table.options.meta` for every table built by `DataTable`. */
export type DataTableMeta = {
  search: string;
};

/**
 * Sorting, filtering and pagination are all server-side, so only the features
 * whose state and APIs the table actually uses are registered — the sorted,
 * filtered and paginated row models stay out of the bundle.
 */
export const dataTableFeatures = tableFeatures({
  columnOrderingFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  rowExpandingFeature,
  rowPaginationFeature,
  rowSelectionFeature,
  rowSortingFeature,
  expandedRowModel: createExpandedRowModel(),
  tableMeta: {} as DataTableMeta,
});

export type DataTableFeatures = typeof dataTableFeatures;
